import { createDomain, sample } from 'effector'
import { driverModel } from '~/entities/common/Driver'
import { requestDriverSilentFx } from '~/entities/common/Driver/model'
import { AxiosErrorType, Driver } from '~/shared/api'
import { logger } from '~/shared/lib/logger'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { isString } from '~/shared/lib/utils'

export const domain = createDomain(
  'page.common.drivers.editDriver.ui.ForceApprove',
)

export const forceApprove = domain.createEvent<{ closeModal: () => void }>()
export const forceApproveFx = domain.createEffect<
  { driverId: UniqueId; closeModal: () => void },
  void,
  AxiosErrorType
>({
  async handler({ driverId, closeModal }) {
    const driver = new Driver(undefined, driverId)
    await driver.forceApprove()
    closeModal()
  },
})

sample({
  clock: forceApprove,
  source: driverModel.$id,
  filter: isString,
  fn: (driverId, { closeModal }) => ({ driverId, closeModal }),
  target: forceApproveFx,
})

sample({
  clock: forceApproveFx.doneData,
  fn() {
    return {
      messageI18n: 'alert.driver force approved' as const,
      variant: 'success' as const,
    }
  },
  target: snackbarEnqueued,
})

sample({
  clock: forceApproveFx.failData,
  fn(e) {
    logger.error(e)
    return {
      message: mapMessageErrors(e),
      variant: 'error' as const,
    }
  },
  target: snackbarEnqueued,
})

sample({
  clock: forceApproveFx.doneData,
  source: driverModel.$id,
  filter: isString,
  target: requestDriverSilentFx,
})
